/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbEnveloppeTypeFinancementGridDto } from './FcbEnveloppeTypeFinancementGridDto';
import {
    FcbEnveloppeTypeFinancementGridDtoFromJSON,
    FcbEnveloppeTypeFinancementGridDtoFromJSONTyped,
    FcbEnveloppeTypeFinancementGridDtoToJSON,
} from './FcbEnveloppeTypeFinancementGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbEnveloppeTypeFinancementGridDtoPaginatedResults
 */
export interface FcbEnveloppeTypeFinancementGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeTypeFinancementGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbEnveloppeTypeFinancementGridDto>}
     * @memberof FcbEnveloppeTypeFinancementGridDtoPaginatedResults
     */
    results?: Array<FcbEnveloppeTypeFinancementGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbEnveloppeTypeFinancementGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbEnveloppeTypeFinancementGridDtoPaginatedResults interface.
 */
export function instanceOfFcbEnveloppeTypeFinancementGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbEnveloppeTypeFinancementGridDtoPaginatedResultsFromJSON(json: any): FcbEnveloppeTypeFinancementGridDtoPaginatedResults {
    return FcbEnveloppeTypeFinancementGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbEnveloppeTypeFinancementGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbEnveloppeTypeFinancementGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbEnveloppeTypeFinancementGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbEnveloppeTypeFinancementGridDtoPaginatedResultsToJSON(value?: FcbEnveloppeTypeFinancementGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbEnveloppeTypeFinancementGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

